import React from 'react';
import {
  ImageDescriptionContainer,
  ImageDescriptionName,
  ImageDescriptionPosition
} from './styled.components';
import { useTranslation } from 'react-i18next';

const ImageDescription = ({ color }) => {
  const { t } = useTranslation();

  return (
    <>
      <ImageDescriptionContainer>
        <ImageDescriptionName color={color}>
          Kacper Raciborski
        </ImageDescriptionName>
        <ImageDescriptionPosition
          color={
            color
          }>{t`for-companies.id-position`}</ImageDescriptionPosition>
      </ImageDescriptionContainer>
    </>
  );
};

export default ImageDescription;
